/**
 * Shown in the portal to a signed-in client account that isn't linked to a
 * client yet (e.g. self-registered, not invited): what to do — contact the
 * studio — and a way out (sign out). Never a "couldn't load" error.
 */

import { Link2Off, LogOut } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button, EmptyState } from '@/components/ui';
import { useAuth } from '@/hooks';

export function PortalNotLinked() {
  const { t } = useTranslation('portal');
  const { logout } = useAuth();
  const signOut = (
    <Button variant="outline" onClick={logout}>
      <LogOut className="mr-1 h-4 w-4" aria-hidden />
      {t('layout.signOut')}
    </Button>
  );
  return <EmptyState icon={Link2Off} title={t('notLinked.title')} description={t('notLinked.description')} action={signOut} />;
}
